import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import { FormControl, InputLabel, Checkbox, FormControlLabel, Select, MenuItem, TextField, Input, ListItemText } from '@material-ui/core';
import { QuestionType } from '../../constants/Enum/ModuleEnum';

interface IQuestionDefaultAnswerComponentProps {
    classTypeId: number;
    inputType: QuestionType;
    defaultQuestionResponses: any;
    updateDefaultQuestionResponses: (defaultQuestionResponses: any) => void;
    pageNumber: number;
    clusterIndex: number;
    questionIndex: number;
    options: any;
    isAutoCalculationApply: boolean;
}

interface IQuestionDefaultAnswerComponentState {
    defaultQuestionResponses: any;
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

/** Renders default answer(s) for a question */
export default class QuestionDefaultAnswerComponent extends React.Component<IQuestionDefaultAnswerComponentProps, IQuestionDefaultAnswerComponentState> {
    constructor(props: any) {
        super(props);

        this.state = {
            defaultQuestionResponses: []
        }
    }

    componentDidMount() {

        const { defaultQuestionResponses, inputType, options } = this.props;

        if (inputType === QuestionType.Checkbox && defaultQuestionResponses && Array.isArray(defaultQuestionResponses) && defaultQuestionResponses.length === 0) {
            this.updateDefaultResponseForCheckbox(options, defaultQuestionResponses);
        }
        else {
            this.setState({ defaultQuestionResponses: (defaultQuestionResponses ? defaultQuestionResponses : []) });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: IQuestionDefaultAnswerComponentProps) {

        if (nextProps.inputType === QuestionType.Checkbox) {
            this.updateDefaultResponseForCheckbox(nextProps.options, nextProps.defaultQuestionResponses);
        }
        else if (nextProps.inputType === QuestionType.Dropdown || nextProps.inputType === QuestionType.Radiobutton) {
            this.updateDefaultResponseForDropdownAndRadioButton(nextProps.options, nextProps.defaultQuestionResponses);
        }
        else {
            this.setState({ defaultQuestionResponses: nextProps.defaultQuestionResponses });
        }
    }

    render() {
        return (
            <>
                <Grid container={true} spacing={8}>
                    <Grid item={true} xs={1}>&nbsp;</Grid>
                    {
                        this.renderControls()
                    }
                </Grid>
            </>
        )
    }

    // Update the default response for dropdown and radio button control 
    private updateDefaultResponseForDropdownAndRadioButton = (options: any, defaultQuestionResponsesProp: any) => {
        if (!Array.isArray(options) || options.length <= 0) {
            return;
        }

        const { classTypeId } = this.props;
        const defaultQuestionResponses = [];

        for (let controlIndex = 1; controlIndex <= classTypeId; controlIndex++) {
            const controlOptions = options[controlIndex - 1] && options[controlIndex - 1].choices;

            if (controlOptions && controlOptions.length > 0) {
                const defaultResponse = defaultQuestionResponsesProp.find((resp: any) => resp.class_type === controlIndex);
                const response = { class_type: controlIndex, value: "", is_Editable: defaultResponse && defaultResponse.is_Editable ? true : false };

                if (defaultResponse) {
                    const existingOption = controlOptions.find((option: any) => option.value === defaultResponse.value);

                    if (existingOption) {
                        response.value = defaultResponse && defaultResponse.value;
                    }
                }

                defaultQuestionResponses.push(response);
            }
        }

        this.setState({ defaultQuestionResponses });
    }

    // Update the default response for checkbox control 
    private updateDefaultResponseForCheckbox = (options: any, defaultQuestionResponsesProp: any) => {
        if (!Array.isArray(options) || options.length <= 0) {
            return;
        }

        const { classTypeId } = this.props;
        const defaultQuestionResponses = [];

        for (let controlIndex = 1; controlIndex <= classTypeId; controlIndex++) {
            const checkboxOptions = options[controlIndex - 1] && options[controlIndex - 1].choices;

            if (checkboxOptions && checkboxOptions.length > 0) {
                const defaultResponse = defaultQuestionResponsesProp.find((resp: any) => resp.class_type === controlIndex);
                const response = { class_type: controlIndex, value: [], is_Editable: defaultResponse && defaultResponse.is_Editable ? true : false };

                response.value = checkboxOptions.map((o: any) => {
                    const defaultResponseValue = defaultResponse && defaultResponse.value && Array.isArray(defaultResponse.value) && defaultResponse.value.find((d: any) => d.key.value === o.value);
                    const value = defaultResponseValue && defaultResponseValue.value;

                    return {
                        value: value === true,
                        key: o
                    }
                });

                defaultQuestionResponses.push(response);
            }
        }

        this.setState({ defaultQuestionResponses });
    }

    // handle click event for is editable checkbox 
    private handleIsEditable = (e: any, controlIndex: number) => {
        const { defaultQuestionResponses } = this.state;
        let response = defaultQuestionResponses && defaultQuestionResponses.find((resp: any) => resp.class_type === controlIndex);

        if (response) {
            response.is_Editable = e.target.checked;
        }
        else {
            response = { class_type: controlIndex, value: '', is_Editable: e.target.checked };
            defaultQuestionResponses.push(response);
        }

        this.setState({ defaultQuestionResponses },
            () => {
                this.props.updateDefaultQuestionResponses(defaultQuestionResponses);
            }
        );

    }

    // parse checkbox values( i.e value part of object)  to array of string for checkbox control 
    private parseCheckboxValues = (values: any): any => {
        if (Array.isArray(values)) {
            const parsedValues: any = [];

            values.map((item) => {
                if (item.value) {
                    parsedValues.push(item.key.value);
                }
            });

            return parsedValues;
        }

        return [];
    }

    // parse checkbox values( i.e key part of object)  to array of string for checkbox control 
    private parseCheckboxTexts = (values: any, checkboxOptions: any): any => {
        if (Array.isArray(checkboxOptions) && Array.isArray(values)) {
            const parsedTexts: any = [];

            values.map((item) => {
                const option = checkboxOptions.find(o => o.key.value === item);

                if (option) {
                    parsedTexts.push(option.key.text.en);
                }
            });

            return parsedTexts;
        }

        return [];
    }

    // get the updated value for checkbox control 
    private getUpdatedCheckboxValue = (values: any, response: any) => {
        return response && response.value && response.value.map((currentValue: any) => {
            currentValue.value = values.includes(currentValue.key.value);

            return currentValue;
        });
    }

    // handle the change event for all controls 
    private handleControlChange = (event: any, controlIndex: number, inputType: QuestionType, checkboxOptions?: any) => {
        let value = event.target.value;
        const { defaultQuestionResponses } = this.state;
        let response = defaultQuestionResponses && defaultQuestionResponses.find((resp: any) => resp.class_type === controlIndex);

        if (inputType === QuestionType.Checkbox) {
            value = this.getUpdatedCheckboxValue(value, response);
        }

        if (response) {
            response.value = value;
        }
        else {
            response = { class_type: controlIndex, value, is_Editable: false };
            defaultQuestionResponses.push(response);
        }

        this.setState({ defaultQuestionResponses },
            () => {
                this.props.updateDefaultQuestionResponses(defaultQuestionResponses);
            }
        );
    }

    // Render the controls based on input type 
    private renderControls = () => {
        const { classTypeId, pageNumber, clusterIndex, questionIndex, inputType } = this.props;
        const { defaultQuestionResponses } = this.state;
        const controls: any = [];

        if (inputType === QuestionType.AdminLevel || inputType === QuestionType.Other) {
            return controls;
        }

        for (let controlIndex = 1; controlIndex <= classTypeId; controlIndex++) {
            const response = defaultQuestionResponses && defaultQuestionResponses.find((resp: any) => resp.class_type === controlIndex);

            const control = <Grid item={true} xs={2}>
                <FormControl margin="normal" required={false} fullWidth={true} key={`value_${pageNumber}_${clusterIndex}_${questionIndex}_${controlIndex}`}>
                    {
                        inputType !== QuestionType.Datepicker && < InputLabel htmlFor={`value_${pageNumber}_${clusterIndex}_${questionIndex}_${controlIndex}`}>Class {this.getNumberInWord(controlIndex)} Default Value</InputLabel>
                    }
                    {
                        this.getControl(pageNumber, clusterIndex, questionIndex, controlIndex, response && !this.props.isAutoCalculationApply ? response.value : '')
                    }
                </FormControl>
                <FormControlLabel key={`editable_${pageNumber}_${clusterIndex}_${questionIndex}_${controlIndex}`}
                    control={
                        <Checkbox
                            checked={response ? response.is_Editable : false}
                            onChange={(e: any) => { this.handleIsEditable(e, controlIndex) }}
                            disabled={this.props.isAutoCalculationApply}
                        />
                    }
                    label="Editable"
                />
            </Grid>;
            controls.push(control);
        }

        return controls;
    }

    // Return the control based on input type 
    private getControl = (pageNumber: number, clusterIndex: number, questionIndex: number, controlIndex: number, value: any) => {
        const { inputType, options } = this.props;

        switch (inputType) {
            case QuestionType.Textbox:
            case QuestionType.Numeric:
                return (<>
                    <Input
                        id={`value_${pageNumber}_${clusterIndex}_${questionIndex}_${controlIndex}`}
                        name={`value_${pageNumber}_${clusterIndex}_${questionIndex}_${controlIndex}`}
                        multiline={false}
                        type={inputType === QuestionType.Numeric ? "number" : "text"}
                        onChange={(e: any) => { this.handleControlChange(e, controlIndex, inputType) }}
                        value={value ? value : ''}
                        disabled={this.props.isAutoCalculationApply}
                    />
                </>);

            case QuestionType.Datepicker:
                return (<>
                    <TextField
                        margin="normal"
                        variant="outlined"
                        type="date"
                        label={`Class ${this.getNumberInWord(controlIndex)} Default Value`}
                        value={value}
                        onChange={(e: any) => { this.handleControlChange(e, controlIndex, inputType) }}
                        disabled={this.props.isAutoCalculationApply}
                    />
                </>);

            case QuestionType.Radiobutton:
            case QuestionType.Dropdown:
                return (<>
                    <Select
                        value={value}
                        name={`value_${pageNumber}_${clusterIndex}_${questionIndex}_${controlIndex}`}
                        multiple={false}
                        displayEmpty={true}
                        disabled={this.props.isAutoCalculationApply}
                        onChange={(e: any) => { this.handleControlChange(e, controlIndex, inputType) }}
                        input={<Input id={`select-multiple-checkbox_${questionIndex}_${controlIndex}`} />}
                        inputProps={{
                            name: `select_${pageNumber}_${clusterIndex}_${questionIndex}_${controlIndex}`,
                            id: `select_${pageNumber}_${clusterIndex}_${questionIndex}_${controlIndex}`
                        }}
                    >
                        <MenuItem value={0} key={0} >None</MenuItem>
                        {
                            options && options[controlIndex - 1] && options[controlIndex - 1].choices.map((item: any, key: any) => {
                                return <MenuItem
                                    value={item.value}
                                    key={key}
                                >{item.text.en}</MenuItem>
                            })
                        }
                    </Select>
                </>);

            case QuestionType.Checkbox:
                const parsedValues = this.parseCheckboxValues(value);
                const checkboxOptions = value;

                return (<>
                    <Select
                        value={Array.isArray(parsedValues) ? parsedValues : []}
                        name={`value_${pageNumber}_${clusterIndex}_${questionIndex}_${controlIndex}`}
                        multiple={true}
                        displayEmpty={true}
                        onChange={(e: any) => { this.handleControlChange(e, controlIndex, inputType, checkboxOptions) }}
                        input={<Input id="select-multiple-checkbox" />}
                        renderValue={(selected: any) => this.state.defaultQuestionResponses && this.state.defaultQuestionResponses.length > 0 ? this.renderArrayValue(selected, checkboxOptions) : selected}
                        MenuProps={MenuProps}
                        disabled={this.props.isAutoCalculationApply}
                    >
                        {
                            checkboxOptions && Array.isArray(checkboxOptions) && checkboxOptions.map((item: any, key: any) => {
                                return <MenuItem value={item.key.value} key={key} >
                                    <Checkbox checked={item.value} />
                                    <ListItemText
                                        className={'muliti-checkbox-margin-left'}
                                        primary={item.key.text.en} />
                                </MenuItem>
                            })
                        }
                    </Select>
                </>);

            case QuestionType.Other:
            default:
                return (<></>);
        }
    }

    // if selected values is array then join it with , to show in dropdown field 
    private renderArrayValue = (selected: any, checkboxOptions: any) => {
        const parsedTexts = this.parseCheckboxTexts(selected, checkboxOptions);

        return Array.isArray(parsedTexts) ? parsedTexts.join(', ') : parsedTexts;
    }

    // get the number in text word 
    private getNumberInWord = (controlIndex: number) => {
        switch (controlIndex) {
            case 1:
                return 'One';
            case 2:
                return 'Two';
            case 3:
                return 'Three';
            default:
                return '';
        }
    }
}






// WEBPACK FOOTER //
// ./src/components/questions/QuestionDefaultAnswerComponent.tsx